import { ReactElement, useState } from 'react'

import { TabTitle } from './TabsTitle'

interface TabsProps {
  children: ReactElement[]
}

interface TabChildProps {
  hidden?: boolean
  title?: string
  clickName?: string
}

export function Tabs({ children }: TabsProps): JSX.Element {
  const [selectedTab, setSelectedTab] = useState(0)

  const validTabs = children.filter((el) => !(el as ReactElement<TabChildProps>).props.hidden)
  const isExtendedTab = validTabs && validTabs.length > 6

  return (
    <div className="tabs-wrapper">
      <ul className={`title-container flex list-none ${isExtendedTab && 'justify-between'}`}>
        {validTabs.map((item, index) => (
          <TabTitle
            active={selectedTab == index}
            clickName={(item as ReactElement<TabChildProps>).props.clickName}
            index={index}
            isExtendedTab={isExtendedTab}
            key={index}
            setSelectedTab={setSelectedTab}
            title={(item as ReactElement<TabChildProps>).props.title ?? ''}
          />
        ))}
      </ul>
      {validTabs.map((_i, index) => (
        <div
          className={
            selectedTab == index ? 'active-tab relative z-10 h-full w-full opacity-100' : 'z-0 hidden h-0 w-0 opacity-0'
          }
          key={index}
        >
          {validTabs[index]}
        </div>
      ))}
    </div>
  )
}
